
import { defineComponent, PropType } from 'vue'
import { AnyField, KeyMapper } from '@/modules/_shared/audit-log/types'
import { useAuditLogModule } from '@/modules/_shared/audit-log'
import AuditLogFieldTypesMessage from '@/components/employees-audit-log/field-types/message.vue'
import AuditLogFieldTypesProperty from '@/components/employees-audit-log/field-types/property.vue'
import AuditLogFieldTypesPropertyDiff from '@/components/employees-audit-log/field-types/property-diff.vue'
import AuditLogFieldTypesResource from '@/components/employees-audit-log/field-types/resource.vue'
import AuditLogFieldTypesUnknown from '@/components/employees-audit-log/field-types/unknown-field.vue'

export default defineComponent({
    name: 'audit-log-activity-message-field',
    components: {
        AuditLogFieldTypesUnknown,
        AuditLogFieldTypesResource,
        AuditLogFieldTypesPropertyDiff,
        AuditLogFieldTypesProperty,
        AuditLogFieldTypesMessage
    },
    props: {
        message: {
            type: Array as PropType<AnyField[]>,
            required: true
        },
        keyMapper: {
            type: Object as PropType<KeyMapper>,
            required: true
        }
    },
    setup () {
        const {
            isPropertyField,
            isPropertyDiffField,
            isResourceField,
            isMessageField
        } = useAuditLogModule()
        const componentForField = (field: AnyField) => {
            switch (true) {
            case isPropertyField(field):
                return 'AuditLogFieldTypesProperty'
            case isPropertyDiffField(field):
                return 'AuditLogFieldTypesPropertyDiff'
            case isResourceField(field):
                return 'AuditLogFieldTypesResource'
            case isMessageField(field):
                return 'AuditLogFieldTypesMessage'
            default:
                return 'vue:AuditLogFieldTypesUnknown'
            }
        }

        return {
            componentForField
        }
    }
})
